module.exports = __webpack_public_path__ + "893f2efa6a1339ed47181c2f855f84a4.svg";